<template>
  <CardSurface raised pad="md" class="quote-banner text-center position-relative">
    <blockquote class="quote-banner__text position-relative mb-0">
      <i class="fa-solid fa-quote-left quote-banner__icon" aria-hidden="true" />
      {{ text }}
    </blockquote>
  </CardSurface>
</template>

<script setup>
import CardSurface from '@/components/CardSurface.vue'

defineProps({
  text: { type: String, required: true },
})
</script>

<style scoped>
.quote-banner__text {
  font-size: clamp(1.05rem, 2.5vw, 1.35rem);
  font-weight: var(--nm-font-weight-medium);
  line-height: 1.65;
  color: var(--nm-text-secondary);
  max-width: 46rem;
  margin-inline: auto;
}

.quote-banner__icon {
  display: block;
  font-size: 1.25rem;
  color: var(--nm-accent);
  margin-bottom: 1rem;
  opacity: 0.7;
}
</style>